class ScrollingImages extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.viewport = this.querySelector('[data-si-viewport]');
    this.track = this.querySelector('[data-si-track]');
    this.group = this.querySelector('[data-si-group]');
    if (!this.viewport || !this.track || !this.group) return;

    this.fillTries = 0;
    this.fill();
    this.resizeObserver = new ResizeObserver(() => this.fill());
    this.resizeObserver.observe(this.viewport);

    this.intersectionObserver = new IntersectionObserver(
      ([entry]) => {
        this.classList.toggle('is-paused', !entry.isIntersecting);
      },
      { threshold: 0.05 }
    );
    this.intersectionObserver.observe(this);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.intersectionObserver?.disconnect();
  }

  fill() {
    const viewportWidth = this.viewport.offsetWidth;
    if (viewportWidth <= 0) {
      this.fillTries = (this.fillTries || 0) + 1;
      if (this.fillTries < 8) requestAnimationFrame(() => this.fill());
      return;
    }
    this.fillTries = 0;
    this.style.setProperty('--si-viewport-w', `${viewportWidth}px`);

    if (!this.classList.contains('is-single')) {
      const styles = getComputedStyle(this);
      const perRow = Number.parseFloat(styles.getPropertyValue('--si-per-row')) || 1;
      const gap = Number.parseFloat(styles.getPropertyValue('--si-gap')) || 0;
      const itemW = (viewportWidth - (perRow - 1) * gap) / perRow;
      if (itemW > 0) this.style.setProperty('--si-item-w', `${itemW}px`);
    } else {
      this.style.removeProperty('--si-item-w');
    }

    this.track.querySelectorAll('[data-si-clone]').forEach((node) => node.remove());
    [...this.group.children].forEach((item) => {
      if (!item.hasAttribute('data-original')) item.remove();
    });

    const originals = [...this.group.querySelectorAll('[data-original]')];
    if (!originals.length) return;

    let guard = 0;
    while (this.group.offsetWidth < viewportWidth && guard < 16) {
      originals.forEach((item) => {
        const copy = item.cloneNode(true);
        copy.removeAttribute('data-original');
        this.group.appendChild(copy);
      });
      guard += 1;
      if (originals[0].offsetWidth === 0) break;
    }

    const clone = this.group.cloneNode(true);
    clone.removeAttribute('data-si-group');
    clone.setAttribute('data-si-clone', '');
    clone.setAttribute('aria-hidden', 'true');
    this.track.appendChild(clone);
  }
}

if (!customElements.get('scrolling-images')) {
  customElements.define('scrolling-images', ScrollingImages);
}
